define('shoptheme/components/plugin/universal-analytics',[
	"jquery",
	"cartware/components/_base",
    "jquery-cookie"
], function(
	$,
	Component
) {
	return Component.create({
		$init: function () {
            if (typeof manipulationOfCart === 'function') {
                // On product add
                $(document).on('cartware_cart/add', function(response) {
                    $.cookie.json = true;
                    var productToBasket = $.cookie("productToBasket"),
                        productlist = $.cookie("productlist");
                    if (productToBasket != undefined) {
                        manipulationOfCart(productToBasket, 'add', productlist);
                        $.removeCookie("productToBasket", { path: '/', domain: '.' + document.domain });
                    }
                });

                // On product remove
                $(document).on('cartware_cart/remove', function(response) {
                    $.cookie.json = true;
                    var productOutBasket = $.cookie("productOutBasket");
                    if (productOutBasket != undefined) {
                        manipulationOfCart(productOutBasket, 'remove', '');
                        $.removeCookie("productOutBasket", {path: '/', domain: '.' + document.domain});
                    }
                });
            }
		}
	});
});
